import { Injectable } from '@angular/core';

import { ApiService }           from '../api/api.service';
import { CompanyMessagesModel } from '../companies/models/company.messages';
import { MessengerService }     from '../messages/messenger/messenger.service';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { VendorModel }          from './models/vendor';
import { VendorsFiltersModel }  from './typings/vendors.filters';

@Injectable({
  providedIn: 'root'
})
export class VendorsService {
  public broadcastKey  = 'filterVendors';
  public tableCacheKey = 'vendors';

  constructor (
    private apiService      : ApiService,
    private messengerService: MessengerService,
  ) {}

  get ( params : TableQueryParameters, filters : VendorsFiltersModel ) : Promise<Array<VendorModel>> {
    return this.apiService.stream('/filters', [
        filters.value || '*',
        'vendors',
        params.offset    || 0,
        params.pageSize  || 10,
        params.field     || 'company_name',
        params.direction || 'asc',
        filters.archivedOnly
      ]);
  }

  getCount ( filters : VendorsFiltersModel ) : Promise<number> {
    return this.apiService.get('/filters/count', [
        filters.value || '*',
        'vendors',
        filters.archivedOnly
      ]);
  }

  getDefaultMessages () : Promise<CompanyMessagesModel> {
    return this.apiService.get('/company_message_settings');
  }

  reactivate ( vendor : VendorModel ) : Promise<any> {
    return this.apiService.get('/vendors/reactivate_deleted', vendor.id);
  }

  sendEmail ( vendor : VendorModel, message = '' ) : Promise<any> {
    return this.messengerService.email({
        body         : message,
        email_address: vendor.email,
        name         : vendor.company_name,
        vendor_id    : vendor.id
      });
  }

  sendSms ( vendor : VendorModel ) : Promise<any> {
    return this.messengerService.sms({
        customer_id: vendor.id,
        name       : vendor.company_name,
        send_to    : vendor.mobile
      });
  }
}
